import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Aboutus_24 = (props: RealEstateDataPageComponentData) => {
  const { items, title, titleElement, columns, titleHexa } = props
  return (
    <section className="about-24 p-y-config">
      <Container fluid>
        <Row className="mb-5">
          <ElementHTML
            children={title || ''}
            elementType={titleElement || 'h2'}
            style={{ color: titleHexa }}
          />
        </Row>
        <Row className="pt-lg-5 pt-0">
          {items?.map((item) => (
            <Col
              xs={12}
              md={Number(columns) || 4}
              className='px-3'
            >
              {item.image_gatsby ? (
                <Image
                  className="w-100 image-about"
                  objectFit={'cover'}
                  alt="image-about"
                  image={item.image_gatsby!}
                />
              ) : (
                <img
                  src={item?.image}
                  alt="image-about"
                  className="image-about"
                />
              )}
              <ElementHTML
                children={item.title || ''}
                elementType={'h4'}
                className="mt-4 item-title"
              />
              <ElementHTML
                children={item.paragraph || ''}
                elementType={'p'}
                className="mt-3 mb-5"
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default Aboutus_24
